import script from "./CheckNewLiveList.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckNewLiveList.vue?vue&type=script&setup=true&lang=js"

import "./CheckNewLiveList.vue?vue&type=style&index=0&id=ffea1796&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffea1796"]])

export default __exports__